import PropTypes from 'prop-types';
import ProviderName from './ProviderName';
import RemoveIcon from '../../assets/icons/RemoveIcon.svg?react';
import XButton from '../common/XButton';
import FileList from '../common/FileList';
import useMedicalProvider from '../../hooks/useMedicalProvider';
import UploadButtonGroup from '../common/UploadButtonGroup';
import useDropboxUploadHandler from '../../hooks/useDropboxUploadHandler';
import { reportBtnClasses } from '../common/listItemClasses';
import { providerRowHeaderClasses } from '../common/formClasses';

const inlineSpinnerClasses = "inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent";

const MedicalProvider = ({ providerIndex, providerType, isLocked = false }) => {
    const {
        medicalRecords,
        fileUploadLoading,
        isButonDisabled,
        buttonDisplayText,
        deleteProvider,
        removeMedicalFile,
        onFileUpload,
        handleOpenReorder
    } = useMedicalProvider({ providerIndex, providerType });

    const { handleDropboxSuccess } = useDropboxUploadHandler({
        accept: 'application/pdf',
        onFilesReady: async (validFiles) => {
            await onFileUpload({ file: validFiles });
        }
    });

    return (
        <>
            <div className="w-full!">
                <div className={providerRowHeaderClasses}>
                    <div className={`${reportBtnClasses} w-full!`}>
                        <ProviderName
                            providerIndex={providerIndex}
                            providerType={providerType}
                            isLocked={isLocked}
                        />
                    </div>
                    {fileUploadLoading ? <output className={inlineSpinnerClasses} aria-label="Loading"/> :
                        <XButton
                            variant="iconGhost"
                            className="relative z-[1]"
                            onClick={deleteProvider}
                            disabled={isLocked}
                            aria-label="Remove provider"
                        >
                            <RemoveIcon />
                        </XButton>
                    }
                </div>
            </div>
            <FileList
                files={medicalRecords}
                onRemove={removeMedicalFile}
                isLoading={fileUploadLoading}
                readOnly={isLocked}
                className="relative z-[1]"
            />
            <div className="mt-6 flex items-center justify-end">
                <XButton
                    variant="ghost"
                    buttonText="Organize Records"
                    className="text-primary mr-2 relative z-[1]"
                    onClick={handleOpenReorder}
                    disabled={isLocked}
                />
                <UploadButtonGroup
                    uploadButtonText={buttonDisplayText}
                    uploadButtonProps={{ isBorder: true }}
                    accept="application/pdf"
                    multiple={true}
                    disabled={isButonDisabled || isLocked}
                    isLoading={fileUploadLoading}
                    onFileSelect={onFileUpload}
                    onDropboxSuccess={handleDropboxSuccess}
                    className="justify-end"
                />
            </div>
        </>
    )
}

MedicalProvider.propTypes = {
    providerIndex: PropTypes.number.isRequired,
    providerType: PropTypes.string.isRequired,
    isLocked: PropTypes.bool
};

export default MedicalProvider;
